/*
 * GARP-124 — Click-time collection redirect.
 *
 * Product-card links render clean /products/{handle} hrefs in the server HTML so
 * crawlers only ever see canonical product URLs (no /collections/x/products/y variants).
 * On real user interaction we rewrite the destination to the collection-context URL so the
 * PDP loads with Shopify's `collection` object populated and the server renders the
 * Shop > Collection > Product breadcrumb. Crawlers never fire these events, so the static
 * HTML stays clean.
 *
 * The collection base comes from a `data-collection-url` attribute on the nearest grid /
 * carousel <ul> (already locale-correct from Liquid). We never preventDefault, so native
 * navigation — incl. new-tab, middle-click, modifier-click and keyboard — proceeds to the
 * rewritten href.
 */
(function () {
  const PRODUCTS_RE = /\/products\/[^/?#]+/;

  function nestedHref(anchor) {
    const container = anchor.closest('[data-collection-url]');
    if (!container) return null; // no collection context -> stay clean
    const collectionUrl = container.getAttribute('data-collection-url');
    if (!collectionUrl) return null;

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (e) {
      return null;
    }
    if (url.origin !== window.location.origin) return null; // never touch external links

    const match = url.pathname.match(PRODUCTS_RE);
    if (!match) return null;
    if (url.pathname.indexOf('/collections/') !== -1) return null; // already nested -> idempotent

    const base = collectionUrl.replace(/\/+$/, ''); // locale-correct, trailing slash stripped
    return base + match[0] + url.search + url.hash; // preserves ?variant=... & #hash
  }

  function rewrite(event) {
    const anchor =
      event.target && event.target.closest
        ? event.target.closest('a[href*="/products/"]')
        : null;
    if (!anchor) return;

    const next = nestedHref(anchor);
    if (next && next !== anchor.getAttribute('href')) {
      anchor.setAttribute('href', next); // no preventDefault — let native navigation proceed
    }
  }

  // Capture phase so we run before any card-level stopPropagation (e.g. quick-add swatches).
  document.addEventListener('pointerdown', rewrite, true); // left/middle/modified click, fires before nav
  document.addEventListener('click', rewrite, true); // keyboard activation + synthetic clicks
  document.addEventListener('auxclick', rewrite, true); // middle-click variants
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Enter') rewrite(event);
    },
    true
  );
})();
